<div class="page-header">
  <div class="row">
    <div class="col-auto">
      <h3>{{ title }}</h3>
    </div>
    <div class="col text-end">
      <div class="button-group" role="group" aria-label="toolbar">
        <button *ngIf="backButton" type="button" title="Back" class="btn bg-dark-lighter text-white " (click)="onBack()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <button *ngIf="refreshButton" type="button" title="Refresh" class="btn bg-dark-lighter text-white " (click)="onRefresh()">
          <i class="fa fa-refresh"></i>
        </button>
        <button *ngIf="settingButton" type="button" title="Settings" class="btn bg-dark-lighter text-white " (click)="onSetting()">
          <i class="fa fa-gear"></i>
        </button>
        <button *ngIf="printButton" type="button" title="Print" class="btn bg-dark-lighter text-white " (click)="onPrint()">
          <i class="fa fa-print"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- <a [routerLink]="url">a</a> -->
